<template>
  <div>
    <div class=" row ">
      <label class="col-sm-4  text-lr lh35"><i
          v-if=" Data.data.c_priority==='S'"
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <div>
          <el-upload class="upload-demo"
                     ref="upload" :action='IBMS_API+"IBMS/Public/UploadAttachment"'
                     :headers="uploadHeaders"
                      :file-list="fileList" :auto-upload="true"
                     :http-request="changeFile"
                     :on-remove="handleRemove"
                     :disabled="Data.attr.disabled===undefined?false:Data.attr.disabled">
            <el-button slot="trigger" size="small" type="primary"   v-if="Data.attr.disabled===undefined?true:!Data.attr.disabled">选取文件
            </el-button>

          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";

export default {
  name: "mp4",
  props: [
    'Data'
  ],
  data() {
    return {
      formLabelWidth: '200px',
      fileList: [],
      uploadHeaders:{
        "Authorization":`${store.state.auth_key}`,
        "x-csrftoken":'WEB'
      },
      postData:new FormData(),
      object_id:''
    };
  },
  mounted() {
    this.handle_file(this.Data)
  },
  methods: {
    //自动上传
    changeFile (file) {
      this.fileList=[]
      console.log(this.object_id,'123')
      let fd = new FormData()
      fd.append('file', file.file)// 传文件
      fd.append('upload_type', '上传')
      fd.append('sign', this.object_id)
      fetch(this.IBMS_API+"IBMS/Public/UploadAttachment", {//fetces6语法，同axios/ajax作用
        method: 'POST',
        headers: {
          "Authorization": `${store.state.auth_key}`,
          "x-csrftoken": 'WEB'
        },
        body: fd//不为data为body否则报错
      })
          .then(res => res.json())
          .then(res => {
            console.log(res.content,this.object_id,'45')
                if(res.result===200) {
                  this.object_id = res.content[0].object_id
                  this.$get_function(this.Data, res.content)
                  for (let i in res.content) {
                    this.fileList.push({'name': res.content[i].name, 'url': res.content[i].src})
                  }
                }else{
                  this.$message({
                    message: '上传失败',
                    type: 'error'
                  });
                }
            // this.fileList=[{'name': res.data.content[0].name, 'url': res.data.content[0].src}]


          })
    },
    handleRemove(file,fileList) {
      console.log(file,fileList,'23')
      let fd = new FormData()
      fd.append('file', '')// 传文件
      fd.append('upload_type', '删除')
      fd.append('sign', this.object_id)
      fd.append('delete_src', file.url)
      fetch(this.IBMS_API+"IBMS/Public/UploadAttachment", {//fetces6语法，同axios/ajax作用
        method: 'POST',
        headers: {
          "Authorization": `${store.state.auth_key}`,
          "x-csrftoken": 'WEB'
        },
        body: fd//不为data为body否则报错
      })
          .then(res => res.json())
          .then(res => {
            console.log(res.content,this.object_id,'45')
            this.$get_function(this.Data, res.content)

          })

    },



    jobOnChange(file,file_list){
      if(file.status==='ready'){
        this.fileList=file_list
      }
      // console.log( this.fileList,'01')
    },
    submitUpload() {
      this.fileList.forEach(item => {
        this.postData.append('file', item.raw)
      })
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UploadAttachment',
        data: this.postData,
      }).then((response) => {
        if(response.data.result===200){
          var arry=[]
          for (let i in Object.values(response.data.content)[0]) {
            arry.push({
              url: Object.values(response.data.content)[0][i].src,
              name:Object.values(response.data.content)[0][i].name
            })
          }
          this.$message({
            message: '上传成功',
            type: 'success'
          });
          this.$get_function(this.Data,  Object.keys(response.data.content)[0])
        }
      })
      // this.$refs.upload.submit();
    },
    handle_file(Data){
      for(let i in Data.data.c_value){
        this.fileList.push({'name': Data.data.c_value[i].name, 'url':  Data.data.c_value[i].src})
      }
    },
    downloadFile(file) {
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = file.url;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
        this.$message({
          message: '下载失败',
          type: 'error'
        });
      }

    },
    show_message() {
      this.$message({
        message: '最多上传4个文件',
        type: 'warning'
      });
    },

    get_src(response) {
      // let src = '';
      for (let i in response.content) {
        this.fileList.push({
          url: response.content[i].src,
          name: response.content[i].name
        })
      }
      let temp=[]
      for (let i in this.fileList) {
        if (this.fileList[i].url !== '') {
          temp.push(this.fileList[i].url)
        }
      }
      this.$get_function(this.Data, temp)
      console.log(temp,2324242)
    },
  }
}
</script>

<style scoped>

</style>